import { CreateCourseHeaderCombinedProps } from './types';

const usePresenter = (props: CreateCourseHeaderCombinedProps): CreateCourseHeaderCombinedProps => {
  return props;
};

export default usePresenter;
